import React from 'react';
import { colors } from '../css';
import Image from '../BuildingBlocks/Image';
import CardTag from './CardTag';
import Text from '../BuildingBlocks/Text';

import {
  StyledCardContainer,
  StyledFavouriteButton,
  StyledImageDefault,
  StyledSVGPlacement,
  StyledSVGContainer,
  StyledIconSpacing
} from './Card.styles';
import SVGIcon from '../SVGIcon';
import IgnoreTranslation from '../Localize/ignoreTranslation';

class Card extends React.Component {
  render() {
    const {
      src,
      alt,
      title,
      location,
      name,
      description,
      id,
      href,
      onClick,
      tag,
      tagColor,
      amenities,
      favourite,
      onFavourite,
      locationHref,
      onLocationClick
    } = this.props;

    const isFavourite = favourite === 'selected' ? colors.colorRed : null;
    return (
      <StyledCardContainer id={id}>
        {tag ? <CardTag color={tagColor}>{tag}</CardTag> : null}
        {favourite !== 'hidden' ? (
          <StyledFavouriteButton type="button" onClick={onFavourite}>
            <SVGIcon selectedIcon="favourite" position="absolute" backgroundColor={isFavourite} />
          </StyledFavouriteButton>
        ) : null}

        <a href={href} onClick={onClick}>
          {src ? (
            <Image src={src} alt={alt} title={title} />
          ) : (
            <StyledImageDefault>
              <StyledSVGContainer>
                <StyledSVGPlacement selectedIcon="lodgelinkwhite" iconColor={colors.colorWhite} />
              </StyledSVGContainer>
            </StyledImageDefault>
          )}
        </a>
        <Text.HeadingFifth tagName="h3" color="quaternary" textTransform="uppercase">
          <a href={locationHref} onClick={onLocationClick}>
            {location}
          </a>
        </Text.HeadingFifth>

        <Text.HeadingFourth tagName="h2">
          <a href={href} onClick={onClick}>
            <IgnoreTranslation>{name}</IgnoreTranslation>
          </a>
        </Text.HeadingFourth>

        {description ? <Text.CopyParagraph>{description}</Text.CopyParagraph> : null}
        <div>
          {amenities.map(amenity => (
            <StyledIconSpacing key={amenity}>
              <SVGIcon width="100%" selectedIcon={amenity} />
            </StyledIconSpacing>
          ))}
        </div>
      </StyledCardContainer>
    );
  }
}

export default Card;
